export const descMap = {
    "31-12": "费托合成气去界区",
    "31-121": "费托合成气去界区",
    "31-181": "甲醇合成气去界区",
    "31-182": "甲醇合成气去界区",
    "31-122": "费托合成气去界区",
    "31-19": "来自界区的中压锅炉给水（BFW）",
    "31-191": "来自界区的中压锅炉给水（BFW）",
    "31-1907": "来自界区的中压锅炉给水（BFW）",
    "31-1908": "来自界区的中压锅炉给水（BFW）",
    "31-01": "来自界区的变换原料气",
    "31-17": "未变换合成气来自T-3100101",
    "31-13": "来自界区的未变换原料气",
    "31-52": "燃料气/火炬气至界区",
    "31-131": "来自界区的未变换原料气（经过换热）",
    "31-1102": "费托合成气去界区",
    "31-06": "变换原料气来自 D-3100101",
    "31-23": "酸水来自 D-3100101",
    "31-21": "酸水来自 T-3100107",
    "31-20": "酸水来自 T-3100108",
    "31-0305": "来自T-3100107的变换原料气",
    "31-22": "酸水来自 D-3100105",
    "31-03": "来自E-3100103的变换原料气",
    "31-031": "来自T-3100107的变换原料气",
    "31-02": "来自T-3100107的变换原料气",
    "31-18": "甲醇合成气去界区",
    "31-85": "富CO2甲醇去E-3100102",
    "31-07": "变换原料气去E-3100102",
    "31-5001": "CO2产品气来自E-3100102",
    "31-491": "CO2产品气来自E-3100107",
    "31-0301": "来自E-3100101的变换原料气",
    "31-4950": "CO2产品气去E-3100101",
    "31-1101": "未变换合成气来自E-3100102",
    "31-14": "未变换原料气来自 T-3100108",
    "31-841": "富CO2甲醇的甲醇输入",
    "31-15": "未变换原料气去E-3100107",
    "31-44": "循环气来自E-3100115",
    "S29": "循环气来自D-3100102",
    "S30": "废水去D-3100103(NNF)",
    "T1013V": "未变换合成气来自T-31001013",
    "T1012V": "未变换合成气来自T-31001012",
    "31-171": "未变换合成气来自E-3100107",
    "31-16": "未变换原料气去E-3100107",
    "31-172": "未变换合成气来自T-3100101",
    "31-161": "未变换原料气来自E-3100107",
    "31-25": "富CO2甲醇来自T-3100101",
    "31-251": "富CO2甲醇来自P-3100106",
    "31-252": "富CO2甲醇来自E-3100129",
    "31-2502": "富CO2甲醇来自E-3100129",
    "31-08": "变换原料气去T-3100102A/B",
    "31-591": "泄放气去E-3100103",
    "31-04": "变换原料气来自 D-3100103",
    "31-502": "CO2产品气来自E-3100101",
    "31-51": "CO2产品气去界区",
    "31-511": "CO2产品气去T-3100109A/B",
    "31-592": "泄放气去T-3100109A/B",
    "31-05": "变换原料气去E-3100104",
    "31-041": "变换原料气去T-3100102A/B",
    "31-061": "变换原料气去T-3100102A/B",
    "31-86": "富CO2甲醇去E-3100104",
    "31-4043": "循环气去D-3100102",
    "31-26": "富CO2甲醇去T-3100101",
    "31-27": "富CO2甲醇去T-3100101",
    "31-2502A": "富CO2甲醇去T-3100102A",
    "31-2502B": "富CO2甲醇去T-3100102B",
    "31-09A": "变换原料气去T-3100102A",
    "31-09B": "变换原料气去T-3100102B",
    "31-87B": "富CO2甲醇去T-3100102B",
    "31-87A": "富CO2甲醇去T-3100102A",
    "S51": "来自E-3100108A的富CO2甲醇",
    "31-30AOUT": "来自T-3100102A的富CO2甲醇",
    "31-30AIN": "富CO2甲醇来自T-3100102A",
    "31-3133A": "富CO2甲醇去T-3100102A/T-3100103",
    "31-10A": "变换合成气来自T-3100102A",
    "3132A": "富CO2甲醇来自E-3100110A",
    "31-10A1": "变换合成气来自E-3100110A",
    "31-3132A": "富CO2甲醇去E-3100110A",
    "31-33": "富CO2甲醇去T-3100103",
    "31-3301": "富CO2甲醇去T-3100103",
    "31-33A": "富CO2甲醇去T-3100103",
    "31-31A": "富CO2甲醇去T-3100102A",
    "31-34A": "富H2S甲醇去T-3100103",
    "31-34": "富H2S甲醇去T-3100103",
    "31-32A": "富CO2甲醇去T-3100102A",
    "S56": "富H2S甲醇去E-3100111A",
    "31-65A": "富H2S甲醇去E-3100108A",
    "31-11": "变换合成气来自T-3100102A/B",
    "31-50": "CO2产品气来自T-3100103",
    "31-49": "CO2产品气来自T-3100104",
    "31-10B1": "变换合成气来自E-3100110B",
    "31-10B": "变换合成气来自T-3100102B",
    "31-81": "贫甲醇去T-3100101",
    "31-82A": "贫甲醇去T-3100102A",
    "31-82B": "贫甲醇去T-3100102B",
    "S74": "来自E-3100108B的富CO2甲醇",
    "31-30BOUT": "来自T-3100102B的富CO2甲醇",
    "31-30BIN": "来自E-3100109B的富CO2甲醇",
    "31-3133B": "富CO2甲醇去T-3100103",
    "31-3132B": "富CO2甲醇去E-3100110B",
    "3132B": "富CO2甲醇来自E-3100110B",
    "31-34B": "富H2S甲醇去T-3100103",
    "31-31B": "富CO2甲醇去T-3100102B",
    "31-32B": "富CO2甲醇去T-3100102B",
    "31-33B": "富CO2甲醇去T-3100103",
    "S78": "富H2S甲醇来自E-3100108B",
    "31-65B": "富H2S甲醇去E-3100108B",
    "31-34A1": "富H2S甲醇去T-3100103",
    "31-34B1": "富H2S甲醇去T-3100103",
    "31-66A": "富H2S甲醇去T-3100104",
    "31-66B": "富H2S甲醇去T-3100104",
    "31-29": "预洗甲醇来自T-3100101",
    "31-411": "低压氮气来自E-3100116",
    "31-36IN": "预洗甲醇去T-3100110",
    "31-38": "预洗闪蒸气来自T-3100110",
    "31-36OUT": "预洗甲醇来自T-3100110",
    "31-39": "预洗闪蒸气来自T-3100110",
    "31-35A": "预洗甲醇来自T-3100102A",
    "31-35B": "预洗甲醇来自T-3100102B",
    "31-28": "富H2S甲醇来自T-3100101",
    "T1034L": "T-3100103四段底至五段液相流",
    "T1035V": "T-3100103五段底至四段气相流",
    "31-42": "循环气来自T-3100103",
    "T1031V": "T-3100103二段底至一段气相流",
    "31-46": "富CO2甲醇来自T-3100103",
    "31-4601": "富CO2甲醇来自E-3100113",
    "31-47": "富CO2甲醇去T-3100104",
    "31-4647": "富CO2甲醇来自E-3100113",
    "31-45": "富H2S甲醇来自T-3100103",
    "T1041L": "T-3100104一段底至二段液相流",
    "31-43": "循环气来自T-3100103",
    "31-66": "富H2S甲醇去T-3100104",
    "31-71": "热闪蒸气来自E-3100114",
    "31-41": "来自界区的低压氮气",
    "T1046V": "T-3100104六段底至五段气相流",
    "31-63": "富H2S甲醇去T-3100104",
    "T1045V": "T-3100104五段底至四段气相流",
    "31-48": "富H2S甲醇去T-3100104",
    "31-54": "富CO2甲醇来自T-3100104",
    "31-83": "富CO2甲醇来自T-3100104",
    "31-831": "富CO2甲醇来自T-3100104",
    "31-56": "泄放气来自T-3100104",
    "31-9856": "泄放气",
    "31-9858": "泄放气",
    "31-98": "泄放气",
    "T1041L2": "T-3100104一段底至二段液相流",
    "31-55": "富CO2甲醇来自T-3100104",
    "31-64": "富H2S甲醇来自T-3100104",
    "31-65": "富H2S甲醇去E-3100108A/B",
    "31-691": "富H2S甲醇去E-3100120",
    "31-58": "泄放气来自T-3100104",
    "31-62OUT": "富H2S甲醇来自T-3100104",
    "31-621": "富H2S甲醇去E-3100117",
    "31-8017": "贫甲醇去E-3100117",
    "31-801": "贫甲醇来自E-3100120",
    "31-8019": "贫甲醇去E-3100119",
    "31-8018": "贫甲醇去E-3100118",
    "31-8012": "贫甲醇来自E-3100117",
    "31-622": "富H2S甲醇去E-3100112",
    "31-59": "泄放气去E-3100104",
    "31-62IN": "富H2S甲醇去T-3100103",
    "31-431": "循环气来自E-3100114",
    "31-40": "预洗闪蒸气来自T-3100110",
    "31-711": "热闪蒸气来自T-3100105",
    "31-70": "热闪蒸气来自T-3100105",
    "31-69": "富H2S甲醇去E-3100118A-I",
    "31-72": "热闪蒸气冷凝液",
    "31-79": "富H2S甲醇来自T-3100105",
    "31-7997": "富H2S甲醇去T-3100105",
    "T1052V": "T-3100105二段底至一段气相流",
    "31-37": "预洗甲醇来自T-3100110",
    "31-73": "酸性气体来自T-3100105",
    "31-731": "酸性气体去E-3100125",
    "31-7303": "酸性气体去D-3100103",
    "31-371": "预洗甲醇来自E-3100124",
    "31-78": "富H2S甲醇去P-3100108",
    "31-101": "富H2S甲醇去T-3100105",
    "31-99": "甲醇蒸汽",
    "31-80889": "贫甲醇来自T-3100105",
    "31-80": "贫甲醇去E-3100120",
    "31-88": "贫甲醇去T-3100105",
    "31-891": "贫甲醇去P-3100107",
    "31-901": "甲醇-水来自T-3100105",
    "31-89": "贫甲醇去T-3100106",
    "31-90": "甲醇-水去T-3100106",
    "31-91": "含甲醇废水来自T-3100106底部",
    "31-95": "尾气洗涤塔废水返回T-3100106",
    "S1": "含甲醇废水来自E-3100128",
    "S6": "尾气洗涤塔废水返回T-3100106",
    "S11": "含甲醇废水去T-3100109A",
    "S9": "洗涤水去T-3100109A",
    "S12": "含甲醇废水去T-3100109B",
    "IMPURE": "含甲醇废水排界区",
    "31-61A": "洗涤后尾气排入大气",
    "31-61B": "洗涤后尾气排入大气",
    "S10": "洗涤水去T-3100109B",
    "31-94B": "脱盐水去T-3100109B",
    "31-94A": "脱盐水去T-3100109A",
    "31-95A": "尾气洗涤塔废水返回T-3100106",
    "31-95B": "尾气洗涤塔废水返回T-3100106",
    "S2": "尾气洗涤塔废水返回T-3100106",
    "S5": "尾气洗涤塔废水返回T-3100106",
    "31-60100": "排放气/尾气去T-3100109A/B",
    "31-6010A": "排放气/尾气去T-3100109A",
    "31-6010B": "排放气/尾气去T-3100109B",
    "31-60": "尾气送往T-3100109A/B",
    "31-74": "酸性气来自D-3100103",
    "31-75": "酸性气来自D-3100104",
    "31-77": "富H2S甲醇来自D-3100104",
    "31-76": "酸性气去界区",
    "31-741": "酸性气来自E-3100126",
    "31-57": "尾气送往E-3100127",
    "31-7404": "酸性气体来自E-3100127",
    "31-100": "排放气",
    "31-24": "酸水去界区",
    "D5-acidwater": "酸水来自D-3100105",
    "31-97": "新鲜甲醇",
    "T102A4V": "T-3100102A四段底至三段气相流",
    "T102A3V": "T-3100102A三段底至二段气相流",
    "T102A2V": "T-3100102A二段底至一段气相流",
    "T102B2V": "T-3100102B二段底至一段气相流",
    "T102B3V": "T-3100102B三段底至二段气相流",
    "T102B4V": "T-3100102B四段底至三段气相流",
    "31-67": "富H2S甲醇来自T-3100104",
    "31-692": "富H2S甲醇去T-3100105",
};